// Shared keydown handler for non-button elements that need to behave like a
// button (Enter/Space activation) alongside role="button" + tabIndex={0}.
export const onKeyActivate = (handler) => (event) => {
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    handler(event);
  }
};
